import { useEffect, useState } from "react";
import { useReactMediaRecorder } from "react-media-recorder";
import { MediaRecorder } from "extendable-media-recorder";
import {
  addFileToUpload,
  resetUpload,
} from "@microdoing/shared/services/upload/actions";

import { useDispatch } from "react-redux";

const EVENT_NAME = "dataavailable";

const requestRecorder = async () => {
  try {
    const stream = await navigator?.mediaDevices?.getUserMedia({ audio: true });

    return new MediaRecorder(stream, { mimeType: "audio/wav" });
  } catch (error) {
    console.log(error);
  }
};

export const recordAudio = () => {
  const [error, setError] = useState("");
  const [time, setTime] = useState(0);
  const [isAudioActivated, setIsAudioActivated] = useState(false);
  const [recorder, setRecorder] = useState<any>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [audio, setAudio] = useState<any>(null);
  const [mediaStatus, setMediaStatus] = useState("");

  const onStop = async (blobUrl, blob) => {
    setIsAudioActivated(false);
    setAudio(blobUrl);

    dispatch(
      addFileToUpload({
        file: blobUrl,
        uri: blobUrl,
        fileName: "recording.wav",
        fileType: "audio/wav",
      }),
    );
    await resetAudio();
  };

  const {
    status,
    startRecording,
    pauseRecording: pause,
    stopRecording,
    resumeRecording,
    clearBlobUrl,
    previewStream,
  } = useReactMediaRecorder({
    video: false,
    screen: false,
    audio: true,
    onStop,
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (!recorder) {
      requestRecorder().then((media: any) => setRecorder(media));
    }
  }, []);

  const onStartRecording = async () => {
    setError("");
    recorder?.start();
    recorder?.stop();
    startRecording();
    setIsAudioActivated(true);
  };

  const onStopRecording = async () => {
    setIsAudioActivated(false);
    stopRecording();
  };

  const pauseRecording = async () => {
    setIsAudioActivated(false);
    // stopRecording();
    // await AudioRecorder.stopRecording();
  };

  const handleData = e => {
    const file = new Blob([e.data], { type: "audio/wav" });
    const url = URL.createObjectURL(file);
    onStop(url, null);
  };

  useEffect(() => {
    if (!recorder) return;

    if (!isAudioActivated && isPlaying) {
      setMediaStatus("stopped");
      setIsPlaying(false);
      stopRecording();
    }

    recorder.addEventListener(EVENT_NAME, handleData);
    return () => recorder.removeEventListener(EVENT_NAME, handleData);
  }, [recorder, isAudioActivated]);

  const takeAudio = async () => {
    setError("");
    recorder?.start();
    startRecording();
    setIsAudioActivated(true);
    setIsPlaying(true);
  };

  const resetAudio = async () => {
    stopRecording();
    setIsPlaying(false);
    clearBlobUrl();

    const tracks = previewStream?.getVideoTracks();
    tracks?.map(mediaStreamTrack => mediaStreamTrack?.stop());

    await navigator?.mediaDevices
      ?.getUserMedia({ audio: true })
      .then(stream => {
        stream?.getTracks().forEach(track => {
          track.stop();
          stream.removeTrack(track);
        });

        stream?.getAudioTracks().forEach(function (track) {
          track.stop();
        });

        stream?.getVideoTracks().forEach(function (track) {
          track.stop();
        });
      });

    await navigator?.mediaDevices
      ?.getUserMedia({ audio: true, video: true })
      .then(stream => {
        stream.getTracks().forEach(track => {
          track.stop();
          stream.removeTrack(track);
        });

        stream.getAudioTracks().forEach(function (track) {
          track.stop();
        });

        stream.getVideoTracks().forEach(function (track) {
          track.stop();
        });
      });

    recorder?.removeEventListener(EVENT_NAME, handleData);
    setMediaStatus("");
    setAudio(null);
    setRecorder(null);
    dispatch(resetUpload());
  };

  return [
    error,
    setError,
    takeAudio as any,
    onStartRecording as any,
    onStopRecording as any,
    pauseRecording as any,
    time,
    isAudioActivated,
    resetAudio as any,
  ];
};
